import { AutogenModelStopWithDetention, AutogenRowStopWithDetention } from "./autogen/AutogenModelStopWithDetention";

export class ModelStopWithDetention extends AutogenModelStopWithDetention<RowStopWithDetention> {
	constructor() {
		super(RowStopWithDetention);
	}
}

export class RowStopWithDetention extends AutogenRowStopWithDetention {
}
